{
  "footer": {
    "copyright": "© 2026 Ef Es Academy Ltd. ⋅ <2>Политика конфиденциальности</2>"
  },
  "nav": {
    "about-us": "О нас",
    "contacts": "Контакты",
    "home": "Главная",
    "services": "Услуги",
    "solutions": "Решения"
  },
  "privacy-policy-url": "/legal/privacy-policy/latest-en",
  "sec1": {
    "button-employee-login": "Вход для сотрудников",
    "button-manager-login": "Вход для компаний",
    "open-in": "Открыть в",
    "title1": "Цифровая трансформация безопасности пищевых продуктов",
    "title2": "Без бумаги. Все в телефоне."
  },
  "sec2": {
    "left": {
      "item1": "Цифровая платформа для входного контроля и контрольных карт",
      "item2": "Онлайн обучение сотрудников в области безопасности пищевых продуктов",
      "item3": "Электронный архив документов",
      "item4": "Консультирование при открытии объектов",
      "item5": "Документация HACCP",
      "item6": "Внутренние проверки и аудиты",
      "title": "Наши решения"
    },
    "right": {
      "item1": "Без бумаги – все в телефоне",
      "item2": "Видеоуроки и тесты, организованные по должностям и уровням – легко и эффективно",
      "item3": "Автоматические напоминания о сроках",
      "item4": "Экономия времени и ресурсов",
      "item5": "Легкая интеграция в повседневную работу",
      "item6": "Создано консультантами с многолетним опытом в области безопасности пищевых продуктов",
      "title": "Преимущества"
    }
  },
  "sec3": {
    "service1": {
      "item1": "Удобный интерфейс, значительно сокращающий время заполнения",
      "item10": "Административная панель для централизованного контроля заполнения",
      "item2": "AI – Мониторинг контрольных карт",
      "item3": "Обнаружение ошибок, отсутствующих значений и нереалистичных данных",
      "item4": "Интеллектуальный анализ данных для повышения безопасности",
      "item5": "Отчеты и рекомендации по улучшению",
      "item6": "Повышенная прозрачность и отслеживаемость",
      "item7": "Установка сроков для заполнения",
      "item8": "Быстрый доступ к заполненным контрольным картам при проверке",
      "item9": "Надёжный архив заполненных контрольных карт",
      "subtitle": "Упрощенное заполнение контрольных карт прямо со смартфона",
      "title": "Электронные контрольные карты"
    },
    "title": "Услуги"
  },
  "sec5": {
    "consulting": {
      "group1": {
        "item1": "Объективная оценка и реальное представление о состоянии объекта",
        "item2": "Проверки на месте по утвержденным чек-листам",
        "item3": "Фотоматериалы и конкретные рекомендации",
        "item4": "Сопоставление фактического состояния и записей в системе",
        "item5": "Отчет с анализом и рекомендациями для владельца/управляющего",
        "title": "Внутренние проверки"
      },
      "group2": {
        "item1": "Профессиональная помощь с первого дня",
        "item2": "Подготовка к первоначальной регистрации",
        "item3": "Проверка технологических проектов и потоков",
        "title": "Консультирование при открытии пищевых объектов"
      },
      "group3": {
        "item1": "Полная система документов, готовая для практического применения",
        "item2": "Разработка и внедрение плана HACCP",
        "item3": "Актуализация документации при изменениях",
        "title": "Документация и HACCP"
      },
      "subtitle": "Для бесперебойной работы пищевых объектов"
    },
    "organizer": {
      "item1": "Контролируемый доступ сотрудников к документам",
      "item2": "Возможность добавления напоминаний об обновлении истекающих документов",
      "item3": "Надежное хранение документов",
      "subtitle": "Цифровой архив всех важных для организации документов по учреждениям"
    },
    "service2": {
      "item1": "Прямое добавление документов через камеру телефона в защищенное облачное пространство, без загрузки его памяти",
      "item2": "Возможность работы нескольких сотрудников одновременно – сотрудник, делопроизводитель, бухгалтер, контрольный орган",
      "item3": "Просмотр, совместное использование или печать уже созданных документов",
      "item4": "Поиск и фильтрация документов по заданным критериям",
      "subtitle": "Экономит время и усилия на ручную обработку сопроводительных документов",
      "title": "Входной контроль"
    },
    "subtitle1": "Консультационные услуги",
    "subtitle4": "Органайзер",
    "training": {
      "item1": "Систематизированное и актуальное содержание – более 130 страниц материала в 10 видеоуроках по около 20 минут",
      "item2": "Соответствует мировым высоким требованиям качества и эффективности обучения",
      "item3": "Тестовая форма проверки знаний",
      "item4": "Легкая организация обучения в соответствии с нуждами и занятиями сотрудников",
      "item5": "Возможность планирования освежающих тренировок через календарь платформы",
      "item7": "Курс сертифицирован <2>The CPD Certification Service</2> — ведущей международной организацией по аккредитации обучения для непрерывного профессионального развития (CPD).",
      "subtitle": "Заменяет лекционную форму на современное и привлекающее внимание мультимедийное обучение",
      "subtitle1": "Обучение по безопасности пищевых продуктов"
    }
  },
  "sec6": {
    "p1": "Food Safety Academy создана с одной ясной миссией – сделать безопасность пищи реальной практикой, а не просто документом. Мы верим, что качественная и безопасная пища – это результат знаний, применяемых ежедневно – не только во время проверок, но и в каждый рабочий день каждым членом команды.",
    "p2": "Наши продукты и обучения разработаны так, чтобы объединять теорию с реальным опытом из профессиональной кухни и контрольной практики. Они дают людям уверенность работать правильно, а бизнесу – спокойствие и прослеживаемость.",
    "p3": "Мы знаем, что в среде, где часто делаются компромиссы, настоящий профессионализм начинается с личной ответственности. Поэтому наша команда создает решения, которые помогают компаниям строить культуру безопасности – основанную на знаниях, прозрачности и реальных действиях.",
    "p4": "Food Safety Academy – потому что это имеет значение.",
    "title": "О нас"
  },
  "sec7": {
    "demo": "Для 10-минутного демо",
    "email": "Email: <1>office@fsacademy.bg</1>",
    "phone": "Телефон: <1>+359 895 77 55 12</1>",
    "title": "Свяжитесь с нами"
  },
  "sec8": {
    "subtitle": "Присоединяйтесь к команде",
    "text": "Если вы хотите участвовать в распространении этого обучения, свяжитесь с нами для получения дополнительной информации на <2>office@fsacademy.bg</2> с заголовком <5>Дистрибуция и распространение</5>",
    "title": "Карьера"
  },
  "subtitle": "Цифровая платформа для безопасности пищевых продуктов",
  "title": "Food Safety Academy"
}
